(function(window, document, $) {
    "use strict";
    var searchHandler = {
        init: function() {
            this.bindEvents();
        },

        bindEvents: function () {
            $('.search-form-inline__reset__button').on('click', function (e) {
                e.preventDefault();
                var $searchFormInlineReset = $('.search-form-inline__reset');
                $searchFormInlineReset.addClass('search-form-inline__reset--pre-remove');

                $('input[type="hidden"][name="typ"]').remove();
                $('.search-form-inline').submit();
            });
        }
    };

    $(document).ready(function() {
        searchHandler.init();
    });
})(window, document, jQuery);

